import { format, parseISO } from "date-fns";
import { CalendarBlank } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { useT } from "../i18n";

export const DatePicker = ({ value, onChange, disabled, testId, placeholder }) => {
  const { t } = useT();
  const date = value ? parseISO(value) : undefined;
  const ph = placeholder || t("pickDate");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" disabled={disabled} data-testid={testId} className="rounded-none w-full justify-start font-mono text-sm font-normal h-10 px-3">
          <CalendarBlank size={15} className="mr-2 text-slate-400" />
          {value ? format(date, "yyyy-MM-dd") : <span className="text-slate-400">{ph}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-md" align="start">
        <Calendar mode="single" selected={date} onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
